import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../components/admin/sidebar";
import PageHelp from "../../components/admin/pageHelp";

const AdminPage = ({ isLoggedin, setIsloggedin, setLoading, sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="admin-page">
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className={`sidebar-wrapper ${sidebarOpen ? "sidebar-wrapper--open" : ""}`}>
        <Sidebar
          isLoggedin={isLoggedin}
          setIsloggedin={setIsloggedin}
          setLoading={setLoading}
        />
      </div>

      <Outlet />

      <PageHelp />
    </div>
  );
};

export default AdminPage;
